import { Box, Icon, InlineCopy, Text, Title } from 'components'
import { useEffect, useState } from 'react'
import ReactMarkdown from 'react-markdown'
import { getRelativeTime } from 'utils'
import { useGetQuery, usePostQuery } from 'hooks'
import { Action, Actions, Markdown, Post } from './styles'
import { PostComments } from './PostComments'
import { Vote } from './Vote'

export const ShowPosts = ({ postable_type, postable_id }) => {
  const { data, reFetch } = useGetQuery({
    url: `/posts?postable_type=${postable_type}&postable_id=${postable_id}`,
    enabled: !!(postable_type && postable_id)
  })

  const { data: voteData, post: postVote } = usePostQuery({
    url: '/votes',
    method: 'PUT'
  })

  const [openComments, setOpenComments] = useState({})

  useEffect(() => {
    reFetch(true)
  }, [postable_id, postable_type, voteData])

  const vote = (post, value) => {
    const currentVote = post.vote?.[0]
    const payload = { post_id: post.id }
    if (currentVote?.id) payload.id = currentVote.id
    payload.value = currentVote?.value === value ? 'removed' : value
    postVote(payload)
  }

  const toggleComments = (postId) => {
    setOpenComments((prev) => ({ ...prev, [postId]: !prev[postId] }))
  }

  if (!data || data?.posts?.rows?.length === 0) { return <Box padding="0.5rem">No posts yet, be the first!</Box> }

  return (
    <>
      {data?.posts?.rows?.map((post) => (
        <Post key={post.id}>
          <Title level="4">
            {post.title}
            {' • '}
            <InlineCopy size="0.85rem">
              {getRelativeTime(post?.created_at)}
            </InlineCopy>
          </Title>
          <Markdown className="body"><ReactMarkdown>{post.body}</ReactMarkdown></Markdown>
          {post?.media?.map((img) =>
            img.url
              ? (
              <img
                key={img.url}
                src={`https://storage.googleapis.com/pinmonkey-dash/assets/${img.url}/asset.webp`}
                width="100%"
              />
                )
              : null
          )}
          <Actions>
            <Vote post={post} vote={vote} />
            <Action onClick={() => toggleComments(post.id)} style={{ cursor: 'pointer' }}>
              <Icon icon="comment-outline" />
              <Text size="0.85rem">{post.comments?.length ?? 0}</Text>
            </Action>
          </Actions>
          {openComments[post.id] && (
            <PostComments post={post} onComment={() => reFetch(true)} />
          )}
        </Post>
      ))}
    </>
  )
}
